import React from "react";
import { Outlet } from "react-router-dom";

import SEO from '../SEO/SEO';
import PageTitle from "../SEO/PageTitle";

const NoHeaderFooterLayout = () => {
  return (
    <>
      <PageTitle />
      <SEO />
      <Outlet />
    </>
  );
};

export default NoHeaderFooterLayout;
